<template>
  <a v-if="!isEmpty" v-bind:href="value.href" v-bind:class="styleClass">
    <h1 v-if="type == 'breaking'">{{ bundle.id_11436 }}</h1>
    <div v-if="hasImg || type != 'breaking'" class="img-and-tags">
      <img v-if="!lazy" v-bind:src="imgSrc"/>
      <img v-else="" v-bind:pic="imgSrc" class="lazy"/>
      <div v-if="hasImg && type != 'breaking'" class="img-overlay"></div>
      <i v-if="value.locked" class="locked">
        <i class="fal fa-plus"></i>
        {{ bundle.id_10860 }}
      </i>
      <i v-if="value.playable" class="playable">
        <i></i>
      </i>
      <i class="tags">
        <i v-if="value.advertorial" class="advertorialClass">{{ bundle.id_10942 }}</i>
        <i v-if="value.topicName" class="topic">{{ value.topicName }}</i>
        <i v-if="value.hostName" class="host">{{ value.hostName }}</i>
      </i>
    </div>
    <h1 v-if="type == 'breaking'">{{ value.title }}</h1>
    <h2 v-else-if="type == 'top'">{{ value.title }}</h2>
    <h3 v-else-if="type == 'horizontal'">{{ value.title }}</h3>
    <h4 v-else-if="type == 'vertical'">{{ value.title }}</h4>
    <h5 v-else-if="type == 'small'">{{ value.title }}</h5>
    <h6 v-else="">{{ value.title }}</h6>
  </a>
</template>

<script>
import Vue from "vue";
import Track from "../plugins/track"
Vue.use(Track)
export default {
  name: "front-page-article",
  props: ["id", "value", "type", "lazy"],
  data: function () {
    return {
      bundle: {
        id_11436: "BREAKING",
        id_10860: "Plus",
        id_10942: "Sponsored content"
      },
    };
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
  },
  computed: {
    isEmpty: function () {
      return !this.value || this.value.length === 0;
    },
    styleClass: function () {
      var result = "fp-article";
      if (this.value.highlight) {
        result += " fp-highlight";
      }
      if (this.type == "breaking") {
        result += " breaking"
      }
      if (this.type == "horizontal") {
        result += " horizontal"
      }
      return result;
    },
    hasImg: function () {
      return this.value.image != null;
    },
    imgSrc: function () {
      var url = window.fileDomain + "/layout/260x145.gif";
      if (this.hasImg) {
        url = this.value.image[this.type];
      }
      return url;
    }
  }
}
</script>
